import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';

const contents = {
  about: {
    title: 'Know OenoBank',
  },
  terms: {
    title: 'Terms and condition',
  },
  'privacy-policy': {
    title: 'Privacy & policy',
  },
  help: {
    title: 'Help center',
  },
};

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();
  const { page } = useParams();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (!page || !contents[page]) {
      navigate('/');
    }
  }, [page]);

  return (
    <Elements.PageBase navigate={navigate}>
      <div className={classes.root}>
        <Elements.Navigator title={contents[page]?.title} />

        <Container>
          <Box mt={2} textAlign="justify">
            <section>
              <p>
                G-Vins Sàrl dont le siège est situé rue de Chantepoulet 21,
                1201, Genève, Suisse, informe les utilisateurs du site internet,
                ainsi que ses clients, par la présente politique de confidentialité,
                des traitements de données qu’elle réalise en tant que responsable de traitement.
              </p>
              <p>
                En produisant des effets sur le territoire Suisse, le/la
                {' '}
                <strong>[Raison sociale]</strong>
                {' '}
                se conforme à la Loi fédérale sur la protection des données du 25 septembre 2020.
              </p>
            </section>

            <section>
              <h2>1. Champ d’application</h2>
              <p>
                La présente politique de confidentialité (ci-après « Politique »),
                s’applique quel que soit le moyen ou le support utilisé pour accéder
                à notre site internet et expose les conditions dans lesquelles, lors
                de votre navigation, nous collectons, utilisons et conservons des
                informations vous concernant, ainsi que les choix dont vous disposez
                s’agissant de la collecte, l’utilisation et la divulgation de ces
                informations. Elle s’applique également à l’ensemble des services que
                nous réalisons dans le cadre de nos activités. En accédant au présent site
                internet ou en contractant avec nous, vous reconnaissez avoir lu, compris et
                accepté d’être sujet aux conditions prévues par la présente Politique.
              </p>
            </section>

            <section>
              <h2>2. Définitions</h2>
              <ul>
                <li>
                  <strong>Données personnelles :</strong>
                  {' '}
                  toutes les informations concernant une personne physique identifiée
                  ou identifiable.
                </li>
                <li>
                  <strong>Traitement :</strong>
                  {' '}
                  toute opération relative à des données personnelles, quels que soient
                  les moyens et procédés utilisés, notamment la collecte, l’enregistrement,
                  la conservation, l’utilisation, la modification, la communication, l’archivage,
                  l’effacement ou la destruction de données.
                </li>
                <li>
                  <strong>Responsable de traitement :</strong>
                  {' '}
                  la personne privée ou l’organe fédéral qui, seul ou conjointement avec d’autres,
                  détermine les finalités et les moyens du traitement de données personnelles.
                </li>
                <li>
                  <strong>Sous-traitant :</strong>
                  {' '}
                  la personne privée ou l’organe fédéral qui traite des données personnelles pour
                  le compte du responsable de traitement.
                </li>
                <li>
                  <strong>Violation de la sécurité des données :</strong>
                  {' '}
                  toute violation de la sécurité entraînant de manière accidentelle ou illicite la
                  perte de données personnelles, leur modification, leur effacement ou leur
                  destruction,leur divulgation ou un accès non autorisé à ces données.
                </li>
              </ul>
            </section>

            <section>
              <h2>3. Lorsque vous naviguez sur notre site internet</h2>
              <h2>3.1 Données collectées</h2>
              <h2>3.1.1 Données de navigation</h2>
              <p>
                Lors de votre navigation sur notre site internet, nous sommes amenés
                à collecter les informations suivantes :
              </p>
              <ul>
                <li>Votre adresse IP</li>
                <li>La date et l’heure de votre visite</li>
                <li>Le navigateur utilisé</li>
                <li>La marque de l’équipement que vous utilisez pour vous connecter</li>
              </ul>
              <p>
                De plus, lorsque vous réalisez une demande de contact ou vous inscrivez à
                notre newsletter, nous collectons, avec votre consentement :
              </p>
              <ul>
                <li>Votre nom et prénom</li>
                <li>Votre adresse électronique</li>
                <li>Votre numéro de téléphone</li>
              </ul>

              <h2>3.2 Finalités d’utilisation des données</h2>
              <p>
                En tant que responsable du traitement des données personnelles que nous
                collectons sur notre site, cet article décrit les buts pour lesquels nous
                traitons vos données.
              </p>
              <ul>
                <li>
                  <strong>Fournitures de services :</strong>
                  {' '}
                  Répondre à vos demandes de contact ou d’envoi de newsletter.
                </li>
                <li>
                  <strong>Marketing :</strong>
                  {' '}
                  Vous adresser des informations sur nos services et offres promotionnelles.
                </li>
                <li>
                  <strong>Personnalisation :</strong>
                  {' '}
                  Analyser vos préférences et optimiser votre expérience sur notre site.
                </li>
                <li>
                  <strong>Poursuite de nos intérêts légitimes :</strong>
                  {' '}
                  Inclut la surveillance de l’utilisation du site et l’étude des plaintes.
                </li>
              </ul>

              <h2>3.3 Cookies</h2>
              <ul>
                <li>
                  <strong>Cookies nécessaires :</strong>
                  {' '}
                  Essentiels au fonctionnement du site.
                </li>
                <li>
                  <strong>Cookies de performance :</strong>
                  {' '}
                  Mesurent et améliorent les performances du site.
                </li>
                <li>
                  <strong>Cookies pour une publicité ciblée :</strong>
                  {' '}
                  Utilisés pour vous proposer des publicités pertinentes.
                </li>
              </ul>
            </section>

            <section>
              <h2>4. Lorsque vous êtes client de G-Vins Sàrl</h2>
              <h2>4.1 Données collectées</h2>
              <ul>
                <li>
                  <strong>Données d’identification :</strong>
                  {' '}
                  Nom, prénom, adresse, email, téléphone, etc.
                </li>
                <li>
                  <strong>Données financières :</strong>
                  {' '}
                  Coordonnées bancaires, etc.
                </li>
              </ul>
            </section>

            <section>
              <h2>5. Catégories de destinataires</h2>
              <ul>
                <li>
                  <strong>Sous-traitance :</strong>
                  {' '}
                  Mesures de sécurité équivalentes exigées des sous-traitants.
                </li>
                <li>
                  <strong>Transmission à des tiers :</strong>
                  {' '}
                  Si requis par la loi ou pour protéger nos droits.
                </li>
              </ul>
            </section>

            <section>
              <h2>6. Sécurité et confidentialité des données</h2>
              <p>
                Des mesures techniques et organisationnelles sont mises en place pour protéger
                vos données contre toute manipulation, perte, ou accès non autorisé.
              </p>
            </section>

            <section>
              <h2>7. Communications à l’étranger</h2>
              <p>
                Vos données peuvent être traitées dans les pays suivants : États-Unis,
                Union Européenne, Suisse.
              </p>
            </section>

            <section>
              <h2>8. Vos droits</h2>
              <p>
                Vous avez la possibilité de demander l’accès, la rectification, la transmission
                ou l’effacement de vos données. Pour cela, contactez-nous à :
                {' '}
                <a href="mailto:gvins.geneva@gmail.com">gvins.geneva@gmail.com</a>
                .
              </p>
            </section>

            <section>
              <h2>10. Mise à jour</h2>
              <p>
                Cette Politique peut être modifiée. Veuillez la vérifier régulièrement.
              </p>
            </section>
          </Box>
        </Container>
      </div>
    </Elements.PageBase>
  );
}
